export default __webpack_public_path__ + "static/heavy-three-46ca51aeee3b56442d0a57e5658c5290.jpg";